var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.70996 2.11996L3.11996 6.70996L7.70996 11.3L6.28996 12.71L0.289961 6.70996L6.28996 0.709961L7.70996 2.11996Z",
    stroke: "#04AAF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeftArrow);
export default __webpack_public_path__ + "static/media/Icon-Left-Arrow.2925da81dbadc5f8d6c8b2f40755c500.svg";
export { ForwardRef as ReactComponent };